import React from "react";
import Hero from "../../components/medical/Hero";
import { FAQ_FOR_CANDIDATES } from "../../data/faqForCandidatesData";
import FaqSection from "../../components/FaqSection";
import HighlightedContactSection from "../../components/HighlightedContactSection";

export default function FaqCandidatesPage() {
  return (
    <>
      <Hero title="FAQ für Kandidaten" subheading="Häufige Fragen für Kandidaten und Bewerber." />
      <section className="bg-white pt-0 pb-16">
        <div className="container-app mx-auto">
          <FaqSection items={FAQ_FOR_CANDIDATES} />
        </div>
        <HighlightedContactSection
          heading="Weitere Fragen als Kandidat?"
          description="Ihre Frage war nicht dabei? Wir beantworten sie gerne persönlich."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-faq-kandidaten-contact"
        />
      </section>
    </>
  );
}
